(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-card-swatches').forEach(function (swatchContainer) {
      swatchContainer.addEventListener('click', function (e) {
        const btn = e.target.closest('.product-card-swatch');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();

        const imageUrl = btn.dataset.imageUrl;

        // Update active state
        swatchContainer.querySelectorAll('.product-card-swatch').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        // Find the product card image and swap it
        const card = swatchContainer.closest('product-card, .product-card__content');
        if (!card) return;
        const img = card.querySelector('img[src], .card-gallery img');
        if (img && imageUrl) {
          img.src = imageUrl;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
